import { Box, Link } from "@dea-web/ui";
import { today } from "../../utils/dateUtil";
import { useAppSelector } from "../../store/types";
import { USER_SELECTED_TIMEZONE } from "../../constants";
const packageJson = require("../../../package.json");
import { getTimezonesSelector } from "../../selectors/globalConfigSelectors";
import { getTimezoneSelector } from "../../selectors/settingsSelector";
import SbuxTranslate from "../../components/SbuxTranslate";
import styles from "./styles";
import useCss from "../../hooks/useCss";

const SbuxFooter = () => {
  const timezones = useAppSelector(getTimezonesSelector) as
    | Array<{ value: string; name?: string }>
    | undefined;
  const timezone = useAppSelector(getTimezoneSelector);
  const timezoneObj = timezones?.find((f) => f.value === timezone);
  const classes = useCss(styles);

  return (
    <Box component="footer" className={classes.root}>
      <hr />
      {/* Row 1: Links on left, Version on right */}
      <Box className={classes.row}>
        <Box className={classes.leftSection}>
          <Link
            target="_blank"
            rel="noreferrer"
            href="https://starbucks.service-now.com/selfservice?id=kb_article&sysparm_article=KB0013797"
            className={classes.text}
          >
            <SbuxTranslate>{`Troubleshooting`}</SbuxTranslate>
          </Link>
          <Box component="span" className={classes.text}>
            |
          </Box>
          <Link
            target="_blank"
            rel="noreferrer"
            href="https://www.starbucks.com/store-locator"
            className={classes.text}
          >
            <SbuxTranslate>{`Store Locator`}</SbuxTranslate>
          </Link>
        </Box>
        <Box component="span" className={classes.text}>
          v. {packageJson.versionDate}-{packageJson.version}
        </Box>
      </Box>

      {/* Row 2: Copyright on left, Timezone on right */}
      <Box className={classes.row}>
        <Box component="span" className={classes.text}>
          {`© ${today("YYYY")} `}
          <SbuxTranslate>{`Starbucks Coffee Company. All rights reserved.`}</SbuxTranslate>
        </Box>
        <Box component="span" className={classes.text}>
          <SbuxTranslate>{`${USER_SELECTED_TIMEZONE}`}</SbuxTranslate>
          {timezoneObj?.name?.replace(/ *\([^)]*\)/, "").trim()}
        </Box>
      </Box>
    </Box>
  );
};

export default SbuxFooter;
